import { useEffect, useState } from 'preact/hooks';
import DownIcon from '../Icons/DownIcon';
import style from './SelectBox.css';
import BottomSheet from '../BottomSheet/BottomSheet';
import List from '../List/List';
import ListItem from '../List/ListItem';
import { _className } from '../../../utils/classname.utils';
import { renderIf } from '../../../utils/render.utils';

export default function SelectBox({
  className = '',
  label,
  title,
  placeholder = '',
  helperText = '',
  disabled = false,
  hasError = false,
  options = [],
  value,
  name,
  closeOnChange = false,
  onChange = () => {},
  ...props
}) {
  const [selectedValue, setSelectedValue] = useState(value);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setSelectedValue(value);
  }, [value]);

  const handleOpen = () => {
    if (!disabled) {
      setOpen(true);
    }
  };

  const handleChange = v => {
    onChange(v);
    setSelectedValue(v);
    if (closeOnChange) {
      setOpen(false);
    }
  };

  return (
    <>
      <div
        className={`${className} ${style['select-box']} ${_className(
          hasError,
          style['has-error'],
        )}
      ${_className(disabled, style.disabled)} ${_className(open, style.open)}`}
        onClick={handleOpen}
      >
        <div className={style['select-box-inner']}>
          <div className={style['select-content']}>
            <label>{label}</label>
            {selectedValue ? (
              <span className={style['select-value']}>{selectedValue}</span>
            ) : placeholder ? (
              <span className={style['select-placeholder']}>{placeholder}</span>
            ) : (
              <></>
            )}
          </div>
          <span className={style['select-icon']}>
            <DownIcon width={24} height={24} />
          </span>
        </div>
        {renderIf(
          helperText,
          <span className={`${style['select-helper']}`}>{helperText}</span>,
        )}
      </div>
      {renderIf(
        open,
        <BottomSheet
          title={title}
          onCloseClick={() => {
            setOpen(false);
          }}
        >
          <List>
            {renderIf(
              options.length,
              options.map(el => {
                return (
                  <ListItem
                    title={el}
                    actionable
                    type={ListItem.Type.RADIO}
                    actionProps={{ name, value: el }}
                    selected={selectedValue === el}
                    onClick={() => {
                      handleChange(el);
                    }}
                  />
                );
              }),
            )}
          </List>
        </BottomSheet>,
      )}
    </>
  );
}
